import React from "react";
import { useModal } from "@/components/product/table/modal/context";
import { Styled } from "../styles";
import { Box, Typography } from "@mui/material";
import constant from "@/utils/constant";
import { useDownloadCard } from "./hooks";

interface Template {
    id: string;
    title: string;
    logoURL: string;
    backgroundURL: string;
}

const templates: Template[] = [
    // {
    //     id: "WEG",
    //     title: `Wine Expo Georgia ${new Date().getFullYear()}`,
    //     logoURL: constant.ASSETS.wineExpoGeorgiaLogo,
    //     backgroundURL: constant.ASSETS.wineExpoGeorgiaBackground,
    // },
    {
        id: "sko5",
        title: `Skin Wine Fest 2025 Oslo`,
        logoURL: constant.ASSETS.skinWineFestLogo,
        backgroundURL: constant.ASSETS.skinWineFestBackground,
    },
];

const CardsModal: React.FC = () => {
    const product = useModal(state => state.product);
    const onGenerateCard = useDownloadCard();

    const publicTitle = product?.shortTitle;
    const eid = product?.eid;
    const pid = product?.pid;

    const onClick = (cid: string) => {
        if (!eid || !pid) return;
        onGenerateCard({ cid, eid, pid });
    };

    return (
        <Styled.Body>
            <Typography textAlign="center" variant="body2">
                Product cards can be used to display your product at expos or other events. In the
                future, you will be able to create your own templates that will fit your needs. Do
                you need a custom product card? Please contact us
            </Typography>
            <Styled.CardList>
                {templates.map(i => {
                    const { id, backgroundURL, logoURL, title } = i;
                    return (
                        <Styled.CardListItem key={id} onClick={onClick.bind(this, id)}>
                            <Typography textAlign="center">{title}</Typography>
                            <Box position="relative">
                                <Styled.CardBackground src={backgroundURL} alt="" />
                                <Styled.CardLogo src={logoURL} alt={title} />
                                <Styled.DippiLogo
                                    src={constant.ASSETS.dippiLogo2}
                                    alt="dippi logo"
                                />
                                <Styled.PublicTitle variant="caption">
                                    {publicTitle}
                                </Styled.PublicTitle>
                            </Box>
                        </Styled.CardListItem>
                    );
                })}
            </Styled.CardList>
        </Styled.Body>
    );
};

export default CardsModal;
